
<div class="modal active">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2>Terrain Altitude Cut Options</h2>
      <div class="close" (click)="cancelTerrainAltitudeCut()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  name="ngTerrainAltitudeCutForm" #ngForm="ngForm" id="terrainAltitudeCutForm" class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Calculation Options</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Calculation Name</label>
                  <input name="name" type="text" [(ngModel)]="this.model.calculationName"
                  forbiddenSubstring={{forbiddenSubstringName}}  alphaNumeric #calculationName="ngModel"/>
                  <span class="error" *ngIf="calculationName.errors?.forbiddenName">
                    Name cannot contain {{forbiddenSubstringName}}.
                  </span>
                  <span class="error" *ngIf=" (calculationName.dirty || calculationName.touched) && calculationName.errors?.nonAlphaNumeric">
                    Only alphanumeric characters, hyphens and underscores are allowed.
                  </span>
                </div>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Altitude</label>
                  <div class="coordenates">
                    <input
                      name="feet"
                      type="number"
                      style="max-width: 100px;"
                      [(ngModel)]="this.model.altitudeFT"
                      (ngModelChange)="changeAltitude($event, 'FT')"
                    /><span>[ft]</span>
                    <input
                    name="meters"
                    type="number"
                    style="max-width: 100px;"
                    [(ngModel)]="this.model.altitudeM"
                    (ngModelChange)="changeAltitude($event, 'M')"
                  /><span>[m]</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button type="submit" [ngClass]="ngForm.form.valid ? 'blue' : 'gray'" [disabled]="!ngForm.form.valid" (click)="calculate()">
              OK
            </button>
            <button class="gray" (click)="cancelTerrainAltitudeCut()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
